import { render, staticRenderFns } from "./SpaceDashboard.vue?vue&type=template&id=73fc9cd4"
import script from "./SpaceDashboard.vue?vue&type=script&lang=js"
export * from "./SpaceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports